/** Get a single KB article by ID, including full content */
export const kbArticleGetSpec = {
    uri: '/kb/article/[article]',
    method: 'GET',
    adminOnly: true,
};
